/* eslint-disable */
export default {
  forward: 'Forward',
  ignore: 'Ignore',
  toVoicemail: 'To voicemail',
  answer: 'Answer',
  endAndAnswer: 'End & Answer',
  holdAndAnswer: 'Hold & Answer',
  custom: 'Custom',
  more: 'More',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"toVoicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"answer"@#@ @source: @#@"Answer"@#@
// @key: @#@"endAndAnswer"@#@ @source: @#@"End & Answer"@#@
// @key: @#@"holdAndAnswer"@#@ @source: @#@"Hold & Answer"@#@
// @key: @#@"custom"@#@ @source: @#@"Custom"@#@
// @key: @#@"more"@#@ @source: @#@"More"@#@
